module.exports = __webpack_public_path__ + "static/media/gl.73ae82a7.svg";